import React from 'react';

import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import ErrorContainer from 'containers/shopping-cart/error-container';

const ShoppingCartError = () => {
  return (
    <div>
      <HeaderContainer />
      <ErrorContainer />
      <FooterContainer />
    </div>
  );
};

export default ShoppingCartError;
